function IT(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                <h5 className="recruit_titleline_title">미디어IT</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <p className="recruit_subinfo_text">
                    필요한 역량은 컴퓨터와 기계에 대한 지식입니다.<br />
                    너무 걱정하지 마세요. 와서 배우면 됩니다. 그래도 미리 알아두면 좋은 기반 지식을 뽑아보자면 아래와 같습니다.
                </p>
                <ol className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">서버 관리를 위한 OS (리눅스, 윈도우) 지식</li>
                    <li className="recruit_subinfo_list_inner">SQL 및 네트워크 지식</li>
                    <li className="recruit_subinfo_list_inner">회로 및 방송 신호에 대한 이해</li>
                    <li className="recruit_subinfo_list_inner">코딩(언어 무관)</li>
                </ol>
                <p className="recruit_subinfo_text">
                    방송 기술이라는 특성상 다양한 기술에 대해 넓게 아는 것이 도움이 됩니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    미디어IT팀은 SBS가 글로벌 콘텐츠 기업으로 도약하기 위한 ‘기술적 기반’을 제공하는 핵심 조직이며,<br />
                    서비스 가치를 극대화하는 방송/IT 융합 전문가 육성을 목표로 합니다.<br />
                    <br />
                    미디어IT팀 내에는 아래와 같이 총 3개의 파트가 있습니다.
                </p>
                <em className="recruit_bold_text">IT인프라 파트</em>
                <p className="recruit_subinfo_text">
                    뉴스제작시스템, 주조/광고시스템, 디지털아카이브, 라디오 음원 관리, SNS 자산관리 및 스트리밍, 콘텐츠 유통 등 제작-송출-유통-저장에<br />
                    이르는 주요 방송 IT 시스템의 운영/관리를 수행합니다. 개발자, DBA, 솔루션 엔지니어 등 여러 IT 전문가들과 소통하며 다양한 시스템을<br />
                    구축하고, 워크플로우 전문가로서 각 시스템별 고도화와 장애 관리, 업그레이드를 위해 하드웨어부터 소프트웨어 개발까지 IT 전반의 역량을 발휘하는 파트입니다.
                </p>
                <em className="recruit_bold_text">기반인프라 파트</em>
                <p className="recruit_subinfo_text">
                    프로그램 제작시스템을 비롯하여 트랜스코딩, 통합전송, 렌더링, 웹하드 등 방송제작용 연동시스템을 구축/운영하고 있으며, 사내 시스템의<br />
                    근간을 이루는 각종 네트워크(백본/그룹)와 방송시설의 구축/관리를 수행합니다. 또한, 임직원의 원활한 직무 수행을 위해 24X365 헬프데스크와 통합관제센터를 운영하고 있으며,
                    사이버 해킹과 정보 탈취에 대응하기 위한 전사 보안정책 수립과 보안시스템의 기획/관리도 담당하고<br />있습니다.
                </p>
                <em className="recruit_bold_text">방송인프라 파트</em>
                <p className="recruit_subinfo_text">
                    카메라, 비디오 장비, 오디오 장비 등 방송장비/시설 관리를 통해 제작현장에서 발생하는 이슈에 즉시 대응하는 ‘응급구조대’ 역할을 수행하며,
                    스튜디오, 부조정실, 종편실 등 방송현장에서 필요로 하는 비디오 서버 등의 제작 솔루션 개발에도 직접 참여합니다.
                    스포츠 빅이벤트 시스템 구축을 통해 해외방송시설 운영에도 참여하고, 유튜브 등 새로운 미디어에 방송시설을 접목하는 등 현장 중심의 엔지니어링 파트라 할 수<br />있겠습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    미디어 IT팀에서 중요한 점은 각자 맡은 시스템의 구성 장비들에 대한 지식과 더 나아가 각기 다른 구성원의 지식을 바탕으로<br />
                    다른 시스템에 좋은 시너지를 내는 것이라고 생각합니다. 안정적인 전사 제작 시스템 운영과 기존 시스템을 개선하고<br />
                    신규 시스템을 개발하는 것이 미디어IT팀의 가장 큰 비전입니다. 이를 위해 배움에 목마른 구성원에게는 각종 교육에 대한 기회가<br />
                    열려 있어 자기가 관심 있는 부분을 더욱 발전시킬 수 있습니다. 현업 부서와 협업을 통해 급변하는 미디어 생태계에 걸맞은<br />
                    프로그램 및 시스템을 구현하면서 자신의 능력을 인정받을 수 있습니다. 자신의 커리어에 맞게 안정적인 시스템 운영 및 유지보수 관리를<br />
                    계속할 수도 있고 이곳에서 쌓은 경험을 바탕으로 고도화된 차기 시스템을 기획, 개발하는 등의 역할을 SBS 조직 내에서 할 수 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요, SBS 미디어 IT팀 기반인프라 파트에서 제작시스템(PDS) 담당자로 일하고 있는 김병문입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">IT 담당자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    입사 당시 저는 당시 편집기술팀(現 콘텐츠마스터링팀)에서 일하게 되었습니다. 5년간 팀의 일원으로 근무하면서 종편감독,<br />
                    색 보정 감독으로 방송제작 일선에서 일하면서 많은 지식과 노하우를 체득할 수 있었습니다.
                    콘텐츠마스터링팀에서 다양한 경험을 쌓은 이후 순환근무 대상자로 지금 제가 근무 중인 미디어IT팀으로 팀을 옮기게 되었습니다.
                    팀에 와서 처음 맡은 일은 SBS 뉴스 시스템인 NDS 였고요. 약 2년간 IT 인프라 파트의 NDS 담당자로 일하면서 IT 시스템 엔지니어로의 초석을 다졌습니다.
                    이후 이전 팀에서 배운 제작 경험과<br />더 잘 맞는 제작시스템(PDS)를 담당하게 되면서 현재 기반인프라 파트로 자리를 옮기게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    모든 장애를 미연에 방지하면 좋겠지만, 세상 모든 일이 항상 순조롭지 않듯이 갑작스러운 서버 및 네트워크 장애가 발생하면 그 파급력은<br />상당합니다.
                    방송은 실시간이라는 특성상 짧은 시간 내에 여러 연결 고리 중 원인을 파악하여 해결하는 빠른 트러블 슈팅이 필요합니다.<br />
                    이를 성공했을 때 전사적인 장애를 해결했다는 점에서 보람을 느낍니다.
                    또한, 기존 시스템을 개선해 사용자가 더 편하고 고도화된 시스템을<br />이용할 수 있게 하거나,
                    새로운 프로그램을 개발부터 릴리즈까지 진행해 사내에 적용했을 때 큰 보람을 느낍니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    입사 당시 저의 직업 가치관은 평소 재미있는 일을 하는 것이었습니다(사실 이 부분은 현실적으로 참 어려운 것 같습니다).<br />
                    자신의 소양과 잘 맞는 일을 선택하면 남들보다 적은 힘을 들이고도 일의 능률은 더 잘 나오는 것 같습니다.
                    저의 경우 어려서부터 과학과 공학에 보다 흥미를 느껴 자연스럽게 이과 진학을 계획했습니다.
                    취미로 악기 연주, 방송반 활동, 영상 편집 등을 하면서 같은 어느 순간 학부와 적성을 살려 지상파 방송국에서 일하는 것이 꿈이 되었습니다.
                    SBS 최종 면접에 합격했을 때를 복기해보면 지긋지긋한 취준생 신분을 벗어난 점도 좋았지만, 평소 하고 싶은 일을 할 수 있게 되었다는 점이 가장 큰 기쁨이었습니다.
                    제가 입사준비를 했던 시절에는 방송엔지니어가 정확히<br />무슨 일을 하는지에 대한 정보가 많이 없었습니다.
                    그에 비해 지금은 워낙 유튜브 생태계로 파생된 산업들이 커지면서 어렵지 않게 방송이란<br />개념에 다가설 수 있을 것입니다.
                    오히려 외부환경이 급변하면서 SBS도 과거의 레거시 편집 방법에서 현재의 다변화된 편집기법 사용 및 제작 워크플로우 변화에 앞장서고 있습니다.
                    재밌다면 도전하세요! 함께할 날을 기다리고 있겠습니다.
                </p>
            </div>
        </div>);
}

export default IT;